type DashboardSectionLabelProps = {
  children: React.ReactNode;
};

export function DashboardSectionLabel({ children }: DashboardSectionLabelProps) {
  return (
    <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.14em] text-muted">
      {children}
    </p>
  );
}
